import {createContext} from 'react';


type TabsContextType = {
    enableArrowNavigation?: boolean,
    ellipsis?: boolean,
    value: string | null,
    onChange: (value: string) => void,
    tabPanelId?: string,
    tabsId?: string,
};

const defaultTabsConfig: TabsContextType = {
    enableArrowNavigation: true,
    ellipsis: true,
    value: null,
    onChange: () => {},
    tabPanelId: undefined,
    tabsId: undefined,
};

export const TabsContext = createContext<TabsContextType>(defaultTabsConfig);

TabsContext.displayName = 'TabsContext';
